/* eslint no-multi-spaces: ["error", { exceptions: { "VariableDeclarator": true } }] */

import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'

export default () => {
  $(() => {
    const settingsSelector   = '.js-filter-settings'
    const categorySelector   = '.js-filter-settings__category'
    const groupLabelSelector = '.js-filter-settings__group-label'
    const slickSelector      = '.js-filter-settings__categories'

    const toggleSelector     = '.js-filter-summary__toggle'

    const $filter = $(settingsSelector)

    const $slick = $(slickSelector).slick({
      centerMode: true,
      draggable: false,
      focusOnSelect: true,
      infinite: false,
      mobileFirst: true,
      nextArrow: '<button type="button" class="slick-next"></button>',
      prevArrow: '<button type="button" class="slick-prev"></button>',
      responsive: [{
        // TODO: workaround until fix of https://github.com/kenwheeler/slick/issues/3140
        breakpoint: 1023,
        settings: 'unslick'
      }],
      speed: 200,
      variableWidth: true
    })

    const $toggle = $(toggleSelector)

    // Toggle corresponding category after slide change
    $slick.on('beforeChange', (_event, slick, currentSlide, nextSlide) => {
      const id = slick.$slides.eq(nextSlide).attr('for')
      $(`#${id}`).click()
    })

    // Manually toggle radio buttons to enable collapsing last group
    $(groupLabelSelector).on('click', (event) => {
      event.preventDefault()
      const id = $(event.target).attr('for')
      const $radio = $(`#${id}`)
      $radio.prop('checked', !$radio.prop('checked'))
    })

    // In large viewport we do the slicking ourselves
    $(categorySelector).on('click', (event) => {
      const id = $(event.target).attr('for')
      $(`#${id}`).click()
      $(categorySelector).removeClass('slick-current')
      $(event.target).addClass('slick-current')
      return false
    })

    // Toggle filter settings display
    $toggle.on('click', function () {
      EventBus.trigger('filter-settings:toggle', false)
    })

    EventBus.on('filter-settings:show', (_event, unfiltered) => {
      if (unfiltered) {
        $filter.addClass($filter.data('active-class'))
        $toggle.addClass($toggle.data('active-class'))
        $slick.slick('slickGoTo', 0)
      }
      if (MediaQuery.is('small only')) {
        $(groupLabelSelector).toArray().forEach((groupLabel) => {
          const id = $(groupLabel).attr('for')
          const $radio = $(`#${id}`)
          $radio.prop('checked', false)
        })
      }
    })

    EventBus.on('filter-settings:toggle', () => {
      $filter.toggleClass($filter.data('active-class'))
      $toggle.toggleClass($toggle.data('active-class'))
      $slick.slick('slickGoTo', 0)
    })

    // Event trigger to evaluate the initial filter-settings state
    EventBus.trigger('filter-settings:show', $filter.data('active') && $toggle.data('active'))
  })
}
